module.exports = __webpack_public_path__ + "media/images/icons/help-circle-e96b52be94a2db7e49d094e78d84ed68.svg";